// ────────────────────────────────────────────────────────────
// Shared auth header injection for /api/* fetches.
// ────────────────────────────────────────────────────────────
// Cloudflare Access only fronts the production custom domain
// (timberline-workbench.com). Vite dev (localhost) and *.pages.dev
// preview deploys are open and never get a CF_Authorization cookie,
// so the server-side getUser() falls through to its X-Dev-User-Email
// header fallback. Inject that header in those environments so the
// preview is usable without re-authing through Access.
//
// Followup logged in memory/project_open_items.md: add *.pages.dev to
// the Access application so this branch can be deleted.

const DEV_USER = (import.meta.env.VITE_DEV_USER_EMAIL as string | undefined)
  || 'nicholas@timberlineminerals.com';

function isPreviewHost(): boolean {
  return typeof window !== 'undefined'
    && window.location.hostname.endsWith('.pages.dev');
}

export function shouldInjectDevAuth(): boolean {
  return Boolean(import.meta.env.DEV) || isPreviewHost();
}

export function authHeaders(): Record<string, string> {
  return shouldInjectDevAuth() ? { 'X-Dev-User-Email': DEV_USER } : {};
}
